
import { isAcme } from 'isAcme';

export function applyOpacityToHex(hex, opacity) {
  const strippedHex = hex.replace('#', '');
  const r = parseInt(strippedHex.substring(0,2), 16);
  const g = parseInt(strippedHex.substring(2,4), 16);
  const b = parseInt(strippedHex.substring(4,6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export const colorScale = {
  color1: { // blueberry
    opacity100: '#496ED8',
    opacity70: '#89A0E6',
    opacity50: '#B7C4F0',
    opacity30: '#DAE2F7',
  },
  color2: { // aqua
    opacity100: '#5EBFEA',
    opacity70: '#96D6F1',
    opacity50: '#BBE4F6',
    opacity30: '#D3EDF9',
  },
  color3: { // wintergreen
    opacity100: '#91E5C5',
    opacity70: '#B7EED9',
    opacity50: '#D0F4E6',
    opacity30: '#E0F8EF',
  },
  color4: { // clementine
    opacity100: '#F2866D',
    opacity70: '#F5AA98',
    opacity50: '#F8C2B6',
    opacity30: '#FBDAD3',
  },
  color5: { // gold
    opacity100: '#EAC563',
    opacity70: '#F1D89A',
    opacity50: '#F6E6BD',
    opacity30: '#F9EFD4',
  },
  color6: { // orchid
    opacity100: '#9882C4',
    opacity70: '#BCAED9',
    opacity50: '#D3CAE6',
    opacity30: '#E2DDEF',
  },
  color7: { // sky
    opacity100: '#C2DDF6',
    opacity70: '#D7E8FA',
    opacity50: '#E5F0FC',
    opacity30: '#EEF5FD',
  },
  color8: { // ocean
    opacity100: '#255C99',
    opacity70: '#688EB4',
    opacity50: '#9CB3CD',
    opacity30: '#C4D4E0',
  },
  color9: { // jadeite
    opacity100: '#62B59E',
    opacity70: '#99CFC0',
    opacity50: '#BDE0D6',
    opacity30: '#D4EBE4',
  },
  grey: {
    level6: '#687982', // cool6
    level5: '#81929B', // cool5
    level4: '#A1AFB5', // cool4
    level3: '#CBD2D8', // cool3
    level2: '#EBEFF2', // cool2
    level1: '#F6F7F8', // cool1
  },
  others: {
    link: "#3653D5",
    linkDark: '#2D46B5',
    positive: '#2BAB83',
    negative: '#C45353',
    lightText: '#707070',
    darkText: '#333333',
  },
};

const black= '#000000';
const shadowGrey= '#3E3E3C';
const slateGrey= '#706E6B';
const koalaGrey= '#969492';
const cloudyGrey= '#C9C7C5';
const silverGrey= '#ECEBEA';
const shinyGrey= '#FAFAF9';
const white= '#FFFFFF';

export const greyScale = isAcme ?
  [
    colorScale.others.darkText,   // 0
    colorScale.grey.level6,       // 1
    colorScale.grey.level5,       // 2
    colorScale.grey.level4,       // 3
    colorScale.grey.level3,       // 4
    colorScale.grey.level2,       // 5
    colorScale.grey.level1,       // 6
    white,                        // 7
  ]
  :
  [
    black,        // 0
    shadowGrey,   // 1
    slateGrey,    // 2
    koalaGrey,    // 3
    cloudyGrey,   // 4
    silverGrey,   // 5
    shinyGrey,    // 6
    white,        // 7
  ]
;
